import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddPropertyContactMutationVariables = Types.Exact<{
  input: Types.Property_Contacts_Insert_Input;
}>;


export type AddPropertyContactMutation = { __typename?: 'mutation_root', insert_property_contacts_one?: { __typename?: 'property_contacts', id: any, name?: string | null, number?: string | null, email?: string | null, property_id?: any | null, created_at?: any | null } | null };


export const AddPropertyContactDocument = gql`
    mutation addPropertyContact($input: property_contacts_insert_input!) {
  insert_property_contacts_one(object: $input) {
    id
    name
    number
    email
    property_id
    created_at
  }
}
    `;
export type AddPropertyContactMutationFn = Apollo.MutationFunction<AddPropertyContactMutation, AddPropertyContactMutationVariables>;

/**
 * __useAddPropertyContactMutation__
 *
 * To run a mutation, you first call `useAddPropertyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPropertyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPropertyContactMutation, { data, loading, error }] = useAddPropertyContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPropertyContactMutation(baseOptions?: Apollo.MutationHookOptions<AddPropertyContactMutation, AddPropertyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPropertyContactMutation, AddPropertyContactMutationVariables>(AddPropertyContactDocument, options);
      }
export type AddPropertyContactMutationHookResult = ReturnType<typeof useAddPropertyContactMutation>;
export type AddPropertyContactMutationResult = Apollo.MutationResult<AddPropertyContactMutation>;
export type AddPropertyContactMutationOptions = Apollo.BaseMutationOptions<AddPropertyContactMutation, AddPropertyContactMutationVariables>;